import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import { setA11yContent } from "../../NavigationHelper/actions";
import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import Container from "common-components/Container";
import StyledLink from "common-components/StyledLink";

class EmailNotVerified extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("email not verified", this.props.pageContent.sc_pagetitle);
    }
  }

  render() {
    const { pageContent } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    return (
      <Container>
        <Header style={{ maxWidth: "424px" }}>{pageContent.section_title}</Header>
        <Div>{convertStringToElements(pageContent.section_description)}</Div>

        <StyledLink
          background={pageContent.buttons[1].type}
          linkType="anchor"
          href={pageContent.buttons[1].link}
        >
          {pageContent.buttons[1].text}
        </StyledLink>

        <StyledLink background={pageContent.buttons[0].type} to="/privacy/secure/your-data">
          {pageContent.buttons[0].text}
        </StyledLink>
      </Container>
    );
  }
}

EmailNotVerified.propTypes = {
  setA11yContent: PropTypes.func.isRequired
};

const mapStateToProps = ({ pageContent: { email_not_verified: pageContent } }) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { setA11yContent }
)(EmailNotVerified);

const Div = styled.div`
  max-width: 390px;
  margin-bottom: 56px;

  p {
    padding: 10px 0;
  }

  ${media.mobile`
    margin-bottom: 40px;
  `}
`;
